/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as OtpRouteImport } from './routes/otp'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProjectsIndexRouteImport } from './routes/projects/index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard/index'
import { Route as BrollsIndexRouteImport } from './routes/brolls/index'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as ProjectsNewRouteImport } from './routes/projects/new'
import { Route as ProjectsProjectIdRouteImport } from './routes/projects/$projectId'
import { Route as EditorProjectIdRouteImport } from './routes/editor/$projectId'
import { Route as DashboardPurchaseHistoryRouteImport } from './routes/dashboard/purchase-history'
import { Route as DashboardProfileRouteImport } from './routes/dashboard/profile'
import { Route as DashboardPlansRouteImport } from './routes/dashboard/plans'
import { Route as DashboardDevelopersRouteImport } from './routes/dashboard/developers'
import { Route as DashboardConnectedAccountsRouteImport } from './routes/dashboard/connected-accounts'
import { Route as BrollsProjectIdRouteImport } from './routes/brolls/$projectId'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as AdminRolesRouteImport } from './routes/admin/roles'
import { Route as AdminProfileRouteImport } from './routes/admin/profile'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'

const SignupRoute = SignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const OtpRoute = OtpRouteImport.update({
  id: '/otp',
  path: '/otp',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const BrollsIndexRoute = BrollsIndexRouteImport.update({
  id: '/brolls/',
  path: '/brolls/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdRoute = ProjectsProjectIdRouteImport.update({
  id: '/projects/$projectId',
  path: '/projects/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const EditorProjectIdRoute = EditorProjectIdRouteImport.update({
  id: '/editor/$projectId',
  path: '/editor/$projectId',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() =>
  import('./routes/editor/$projectId.lazy').then((d) => d.Route),
)
const DashboardPurchaseHistoryRoute =
  DashboardPurchaseHistoryRouteImport.update({
    id: '/dashboard/purchase-history',
    path: '/dashboard/purchase-history',
    getParentRoute: () => rootRouteImport,
  } as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/dashboard/profile',
  path: '/dashboard/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPlansRoute = DashboardPlansRouteImport.update({
  id: '/dashboard/plans',
  path: '/dashboard/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardDevelopersRoute = DashboardDevelopersRouteImport.update({
  id: '/dashboard/developers',
  path: '/dashboard/developers',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardConnectedAccountsRoute =
  DashboardConnectedAccountsRouteImport.update({
    id: '/dashboard/connected-accounts',
    path: '/dashboard/connected-accounts',
    getParentRoute: () => rootRouteImport,
  } as any)
const BrollsProjectIdRoute = BrollsProjectIdRouteImport.update({
  id: '/brolls/$projectId',
  path: '/brolls/$projectId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRolesRoute = AdminRolesRouteImport.update({
  id: '/admin/roles',
  path: '/admin/roles',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProfileRoute = AdminProfileRouteImport.update({
  id: '/admin/profile',
  path: '/admin/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/brolls/$projectId': typeof BrollsProjectIdRoute
  '/dashboard/connected-accounts': typeof DashboardConnectedAccountsRoute
  '/dashboard/developers': typeof DashboardDevelopersRoute
  '/dashboard/plans': typeof DashboardPlansRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/purchase-history': typeof DashboardPurchaseHistoryRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin': typeof AdminIndexRoute
  '/brolls': typeof BrollsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/brolls/$projectId': typeof BrollsProjectIdRoute
  '/dashboard/connected-accounts': typeof DashboardConnectedAccountsRoute
  '/dashboard/developers': typeof DashboardDevelopersRoute
  '/dashboard/plans': typeof DashboardPlansRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/purchase-history': typeof DashboardPurchaseHistoryRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin': typeof AdminIndexRoute
  '/brolls': typeof BrollsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/projects': typeof ProjectsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/otp': typeof OtpRoute
  '/reset-password': typeof ResetPasswordRoute
  '/signup': typeof SignupRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/profile': typeof AdminProfileRoute
  '/admin/roles': typeof AdminRolesRoute
  '/admin/users': typeof AdminUsersRoute
  '/brolls/$projectId': typeof BrollsProjectIdRoute
  '/dashboard/connected-accounts': typeof DashboardConnectedAccountsRoute
  '/dashboard/developers': typeof DashboardDevelopersRoute
  '/dashboard/plans': typeof DashboardPlansRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/purchase-history': typeof DashboardPurchaseHistoryRoute
  '/editor/$projectId': typeof EditorProjectIdRoute
  '/projects/$projectId': typeof ProjectsProjectIdRoute
  '/projects/new': typeof ProjectsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/brolls/': typeof BrollsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/projects/': typeof ProjectsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/otp'
    | '/reset-password'
    | '/signup'
    | '/admin/analytics'
    | '/admin/profile'
    | '/admin/roles'
    | '/admin/users'
    | '/brolls/$projectId'
    | '/dashboard/connected-accounts'
    | '/dashboard/developers'
    | '/dashboard/plans'
    | '/dashboard/profile'
    | '/dashboard/purchase-history'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/admin'
    | '/brolls'
    | '/dashboard'
    | '/projects'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/otp'
    | '/reset-password'
    | '/signup'
    | '/admin/analytics'
    | '/admin/profile'
    | '/admin/roles'
    | '/admin/users'
    | '/brolls/$projectId'
    | '/dashboard/connected-accounts'
    | '/dashboard/developers'
    | '/dashboard/plans'
    | '/dashboard/profile'
    | '/dashboard/purchase-history'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/admin'
    | '/brolls'
    | '/dashboard'
    | '/projects'
  id:
    | '__root__'
    | '/'
    | '/forgot-password'
    | '/login'
    | '/otp'
    | '/reset-password'
    | '/signup'
    | '/admin/analytics'
    | '/admin/profile'
    | '/admin/roles'
    | '/admin/users'
    | '/brolls/$projectId'
    | '/dashboard/connected-accounts'
    | '/dashboard/developers'
    | '/dashboard/plans'
    | '/dashboard/profile'
    | '/dashboard/purchase-history'
    | '/editor/$projectId'
    | '/projects/$projectId'
    | '/projects/new'
    | '/admin/'
    | '/brolls/'
    | '/dashboard/'
    | '/projects/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  OtpRoute: typeof OtpRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignupRoute: typeof SignupRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminProfileRoute: typeof AdminProfileRoute
  AdminRolesRoute: typeof AdminRolesRoute
  AdminUsersRoute: typeof AdminUsersRoute
  BrollsProjectIdRoute: typeof BrollsProjectIdRoute
  DashboardConnectedAccountsRoute: typeof DashboardConnectedAccountsRoute
  DashboardDevelopersRoute: typeof DashboardDevelopersRoute
  DashboardPlansRoute: typeof DashboardPlansRoute
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardPurchaseHistoryRoute: typeof DashboardPurchaseHistoryRoute
  EditorProjectIdRoute: typeof EditorProjectIdRoute
  ProjectsProjectIdRoute: typeof ProjectsProjectIdRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  AdminIndexRoute: typeof AdminIndexRoute
  BrollsIndexRoute: typeof BrollsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signup': {
      id: '/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof SignupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/otp': {
      id: '/otp'
      path: '/otp'
      fullPath: '/otp'
      preLoaderRoute: typeof OtpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brolls/': {
      id: '/brolls/'
      path: '/brolls'
      fullPath: '/brolls'
      preLoaderRoute: typeof BrollsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId': {
      id: '/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId'
      preLoaderRoute: typeof ProjectsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/editor/$projectId': {
      id: '/editor/$projectId'
      path: '/editor/$projectId'
      fullPath: '/editor/$projectId'
      preLoaderRoute: typeof EditorProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/purchase-history': {
      id: '/dashboard/purchase-history'
      path: '/dashboard/purchase-history'
      fullPath: '/dashboard/purchase-history'
      preLoaderRoute: typeof DashboardPurchaseHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/dashboard/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/plans': {
      id: '/dashboard/plans'
      path: '/dashboard/plans'
      fullPath: '/dashboard/plans'
      preLoaderRoute: typeof DashboardPlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/developers': {
      id: '/dashboard/developers'
      path: '/dashboard/developers'
      fullPath: '/dashboard/developers'
      preLoaderRoute: typeof DashboardDevelopersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/connected-accounts': {
      id: '/dashboard/connected-accounts'
      path: '/dashboard/connected-accounts'
      fullPath: '/dashboard/connected-accounts'
      preLoaderRoute: typeof DashboardConnectedAccountsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brolls/$projectId': {
      id: '/brolls/$projectId'
      path: '/brolls/$projectId'
      fullPath: '/brolls/$projectId'
      preLoaderRoute: typeof BrollsProjectIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/roles': {
      id: '/admin/roles'
      path: '/admin/roles'
      fullPath: '/admin/roles'
      preLoaderRoute: typeof AdminRolesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/profile': {
      id: '/admin/profile'
      path: '/admin/profile'
      fullPath: '/admin/profile'
      preLoaderRoute: typeof AdminProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  OtpRoute: OtpRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignupRoute: SignupRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminProfileRoute: AdminProfileRoute,
  AdminRolesRoute: AdminRolesRoute,
  AdminUsersRoute: AdminUsersRoute,
  BrollsProjectIdRoute: BrollsProjectIdRoute,
  DashboardConnectedAccountsRoute: DashboardConnectedAccountsRoute,
  DashboardDevelopersRoute: DashboardDevelopersRoute,
  DashboardPlansRoute: DashboardPlansRoute,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardPurchaseHistoryRoute: DashboardPurchaseHistoryRoute,
  EditorProjectIdRoute: EditorProjectIdRoute,
  ProjectsProjectIdRoute: ProjectsProjectIdRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  AdminIndexRoute: AdminIndexRoute,
  BrollsIndexRoute: BrollsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
